(() => {
  const formSelector = '.cntrip-group-tour form.cgt-form';

  const parseRanges = (value) => (value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => {
      const [start, end] = item.split('..').map((part) => part.trim());
      return { start, end: end || start };
    });

  const overlapsRanges = (start, end, ranges) => ranges.some((range) => start <= range.end && end >= range.start);

  const toISODate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  const formatTripDates = (selectedDate, tripDays) => {
    const parts = selectedDate.split('-').map(Number);
    const startDate = new Date(parts[0], parts[1] - 1, parts[2]);
    const endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + tripDays - 1);

    const formatDate = (value) => value.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    return {
      endIso: toISODate(endDate),
      label: `${formatDate(startDate)} – ${formatDate(endDate)}`,
    };
  };

  const formValue = (form, name) => {
    const field = form.elements.namedItem(name);
    return field && 'value' in field ? String(field.value || '').trim() : '';
  };

  const setError = (root, message) => {
    const error = root.querySelector('[data-cgt-error]');
    if (!error) return;
    error.hidden = !message;
    if (message) error.textContent = message;
  };

  const guestLabel = (count) => `${count} ${count === 1 ? 'guest' : 'guests'}`;

  const roomAllocationLabel = (twinCount, singleCount) => {
    const parts = [];
    if (twinCount > 0) parts.push(`${guestLabel(twinCount)} Twin sharing`);
    if (singleCount > 0) parts.push(`${guestLabel(singleCount)} Single room`);
    return parts.join(' + ');
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;

    const root = form.closest('.cntrip-group-tour');
    const dateInput = form.querySelector('[data-cgt-date]');
    const roomsInput = form.querySelector('[data-cgt-rooms]');
    const quantityInput = form.querySelector('[data-cgt-quantity]');
    const variantSelect = form.querySelector('[data-cgt-variant]');
    const submit = form.querySelector('[data-cgt-submit]');

    if (!root || !dateInput || !roomsInput || !quantityInput || !variantSelect) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.dataset.cntripBookingSubmitting === 'true') return;

    const selectedDate = String(dateInput.value || '').trim();
    const count = Math.max(1, Number(quantityInput.value) || 1);
    const minRooms = Math.ceil(count / 2);
    const maxRooms = count;
    const roomCount = Math.min(maxRooms, Math.max(minRooms, Number(roomsInput.value) || minRooms));
    const singleCount = (roomCount * 2) - count;
    const twinCount = count - singleCount;
    const tripDays = Math.max(1, parseInt(root.dataset.tripDays || '1', 10) || 1);

    if (!selectedDate) {
      setError(root, 'Please choose a valid departure date.');
      return;
    }

    const trip = formatTripDates(selectedDate, tripDays);
    const peakRanges = parseRanges(root.dataset.peakRanges);
    const schoolRanges = parseRanges(root.dataset.schoolRanges);

    let period = 'standard';
    if (overlapsRanges(selectedDate, trip.endIso, peakRanges)) period = 'peak';
    else if (overlapsRanges(selectedDate, trip.endIso, schoolRanges)) period = 'school';

    const options = Array.from(variantSelect.options);
    const findOption = (roomType) => options.find((option) => (
      option.dataset.pricingPeriod === period
      && option.dataset.roomType === roomType
      && option.dataset.available === 'true'
    ));

    const twinOption = twinCount > 0 ? findOption('twin') : null;
    const singleOption = singleCount > 0 ? findOption('single') : null;

    if ((twinCount > 0 && !twinOption) || (singleCount > 0 && !singleOption)) {
      setError(root, 'The selected occupancy option is not available for this departure date.');
      return;
    }

    const cartParts = [];
    if (twinOption && twinCount > 0) cartParts.push(`${twinOption.value}:${twinCount}`);
    if (singleOption && singleCount > 0) cartParts.push(`${singleOption.value}:${singleCount}`);

    if (!cartParts.length) {
      setError(root, 'Unable to build this booking. Please check the traveler and room selection.');
      return;
    }

    const pricingLabel = period === 'peak' ? 'Peak holiday' : period === 'school' ? 'School vacation' : 'Standard';
    const tourType = formValue(form, 'properties[Tour type]');
    const guide = formValue(form, 'properties[Guide language]');
    const tourDates = formValue(form, 'properties[Tour dates]') || trip.label;

    const params = new URLSearchParams();
    params.set('attributes[Departure date]', selectedDate);
    params.set('attributes[Tour dates]', tourDates);
    params.set('attributes[Number of travelers]', String(count));
    params.set('attributes[Number of rooms]', String(roomCount));
    params.set('attributes[Room allocation]', roomAllocationLabel(twinCount, singleCount));
    params.set('attributes[Pricing period]', pricingLabel);
    if (tourType) params.set('attributes[Tour type]', tourType);
    if (guide) params.set('attributes[Guide]', guide);
    if (count > 8) params.set('attributes[Group size]', `Large group (${count} travelers)`);

    const routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const normalizedRoot = routesRoot.endsWith('/') ? routesRoot : `${routesRoot}/`;
    const checkoutUrl = `${normalizedRoot}cart/${cartParts.join(',')}?${params.toString()}`;

    form.dataset.cntripBookingSubmitting = 'true';
    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
    }
    setError(root, '');

    window.location.assign(checkoutUrl);
  }, true);
})();
